export default __webpack_public_path__ + "static/media/pahang2021B.bb2d8eda.jpg";